<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="4">
        <v-card
          flat>
          <v-card-text class="black--text">
            <div v-if="alertdata.show">
              <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
            </div>
            <div v-if="loading.detail" class="text-center">
              <v-progress-circular
                :width="3"
                color="red"
                indeterminate>
              </v-progress-circular>
            </div>
            <div
              class="black--text"
              v-if="!loading.detail && detaildata.length > 0">
              <div v-if="detaildata[0].pic_dosen" class="mb-5">
                <v-img
                  :lazy-src="require('../assets/default.jpg')"
                  :src="api + '/upload/dosen/' + detaildata[0].pic_dosen">
                </v-img>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card flat>
          <v-card-text class="black--text">
            <h2 class="text-md-h5 font-weight-bold mb-3 line-h-normal">
              {{ detaildata[0].nama_dosen ? detaildata[0].nama_dosen : 'Nama dosen' }}
            </h2>
            <v-divider class="my-2"></v-divider>
            <v-row>
              <v-col cols="12" md="6">
                <span class="text-subtitle-1">NIP.</span>
                <h2 class="text-md-h6 font-weight-bold mb-3">
                  {{ detaildata[0].nip_dosen ? detaildata[0].nip_dosen : '-' }}
                </h2>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-subtitle-1">Jabatan.</span>
                <h2 class="text-md-h6 font-weight-bold mb-3">
                  {{ detaildata[0].jabatan_dosen ? detaildata[0].jabatan_dosen : '-' }}
                </h2>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-subtitle-1">Prodi.</span>
                <h2 class="text-md-h6 font-weight-bold mb-3">
                  {{ detaildata[0].nama_prodi ? detaildata[0].nama_prodi : '-' }}
                </h2>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-subtitle-1">Email.</span>
                <h2 class="text-md-h6 font-weight-bold mb-3">
                  {{ detaildata[0].email_dosen ? detaildata[0].email_dosen : '-' }}
                </h2>
              </v-col>
              <v-col cols="12" md="12">
                <span class="text-subtitle-1">Deskripsi.</span>
                <div
                  class="text--primary ql-editor"
                  v-html="detaildata[0].profile_dosen">
                </div>
              </v-col>
              <div cols="12" md="12">
                <div class="d-inline">
                  <v-btn
                    class="mr-2 mb-2"
                    fab
                    depressed
                    dark
                    x-small
                    :to="{ name: 'Dosen' }">
                    <v-icon dark>
                      mdi-arrow-left-thick
                    </v-icon>
                  </v-btn>
                  <span class="title" v-if="$i18n.locale === 'id'">Kembali</span>
                  <span class="title" v-if="$i18n.locale === 'en'">Back</span>
                </div>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Profiledosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    detaildata: [],
    catlist: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    paramcategory: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
      notin: '',
    },
    check: {
      nip: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
  }),
  watch: {
    '$route.query.nip'(val) {
      if (val) {
        this.check.nip = val;
        this.getDosen();
      }
    },
  },
  mounted() {
    if (this.$route.query.nip && this.$route.query.nip !== '') {
      this.check.nip = this.$route.query.nip;
      this.getDosen();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      return this.baseurl + '' + props.href;
    },
    getDosen() {
      this.loading.detail = true;
      this.alertdata.show = false;
      this.detaildata = [];
      if (this.check.nip) {
        this.axios
          .get(
            this.api + '/public/dosen/' + this.check.nip,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                // this.getBycategory();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getBycategory() {
      this.catlist = [];
      this.paramcategory.lang = this.$i18n.locale;
      this.paramcategory.limit = 10;
      this.paramcategory.type = this.detaildata[0].type_berita;
      this.paramcategory.category = this.detaildata[0].cat_berita;
      this.paramcategory.notin = this.detaildata[0].id_berita;
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramcategory,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.catlist.push(element);
              });
              // console.log(this.catlist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
